import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
export interface TabItem {
  id: string;
  label: string;
  count?: number;
}
export function Tabs({
  items,
  value,
  onChange,
  layoutId = 'tab-underline',
  className
}: {
  items: TabItem[];
  value: string;
  onChange: (id: string) => void;
  layoutId?: string;
  className?: string;
}) {
  return <div role="tablist" className={cn('no-scrollbar flex gap-1 overflow-x-auto border-b border-hairline', className)} data-id="element-996" data-mp="21yk93827827g">
      {items.map(item => {
      const active = item.id === value;
      return <button key={item.id} role="tab" type="button" aria-selected={active} onClick={() => onChange(item.id)} className={cn('relative shrink-0 px-3.5 pb-3 pt-2 text-sm font-medium transition-colors duration-150 ease-out', active ? 'text-ink' : 'text-ink-3 hover:text-ink-2')} data-id="element-997" data-mp="1s0w5dsmm7kd5">
            {item.label}
            {item.count !== undefined && <span className={cn('tnum ml-1.5 text-xs', active ? 'text-primary' : 'text-ink-3')} data-id="element-998" data-mp="2bpodcco7zjkq">{item.count}</span>}
            {active && <motion.span layoutId={layoutId} className="absolute inset-x-2 -bottom-px h-0.5 rounded-full bg-primary" transition={{
          type: 'spring',
          stiffness: 500,
          damping: 34
        }} data-id="element-999" data-mp="2ponsmtpuem48" />}
          </button>;
    })}
    </div>;
}